import { inject } from '@angular/core';
import { RedirectFunction, Router, Routes } from '@angular/router';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/auth-pages/sign-up/sign-up.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { authGuard } from './pages/auth-pages/guards/auth.guard';
import { superAdminGuard } from './pages/auth-pages/guards/super-admin.guard';
import { adminGuard } from './pages/auth-pages/guards/admin.guard';
import { guestGuard } from './pages/auth-pages/guards/guest.guard';
import { ProfileComponent } from './pages/profile/profile.component';
import { AccountSettingsComponent } from './pages/profile/account-settings/account-settings.component';
import { CurrencyComponent } from './pages/currency/currency-list/currency.component';
import { CurrencyJobConfigsComponent } from './pages/currency/currency-job-configs/currency-job-configs.component';
import { CurrencyJobExecutionsComponent } from './pages/currency/currency-job-executions/currency-job-executions.component';
import { CampaignListComponent } from './pages/marketing-email/campaign-list/campaign-list.component';
import { CampaignFormComponent } from './pages/marketing-email/campaign-form/campaign-form.component';
import { FormsListComponent } from './pages/marketing-forms/forms-list/forms-list.component';
import { TemplatesListComponent } from './pages/marketing-forms/templates-list/templates-list.component';
import { FormEditorComponent } from './pages/marketing-forms/form-editor/form-editor.component';
import { FormEditorGuard } from './pages/marketing-forms/form-editor/form-editor.guard';
import { SubmissionsListComponent } from './pages/marketing-forms/submissions/submissions-list.component';
import { PublicFormComponent } from './pages/public/marketing-form/public-form/public-form.component';

// Contactos
import { ContactoListComponent } from './pages/contactos/contacto-list/contacto-list.component';
import { ContactoFormComponent } from './pages/contactos/contacto-form/contacto-form.component';
import { ContactoKanbanComponent } from './pages/contactos/contacto-kanban/contacto-kanban.component';

//Segmento y listas (contactos)
import { SegmentListComponent } from './pages/segments/segment-list/segment-list.component';
import { SegmentFormComponent } from './pages/segments/segment-form/segment-form.component';

// Empresas
import { EmpresaListComponent } from './pages/empresas/empresa-list/empresa-list.component';
import { EmpresaFormComponent } from './pages/empresas/empresa-form/empresa-form.component';
import { EmpresaKanbanComponent } from './pages/empresas/empresa-kanban/empresa-kanban.component';

//Monedas


// Deals
import { DealListComponent } from './pages/deals/deal-list/deal-list.component';
import { DealFormComponent } from './pages/deals/deal-form/deal-form.component';
import { DealKanbanComponent } from './pages/deals/deal-kanban/deal-kanban.component';

// Productos
import { ProductoListComponent } from './pages/productos/producto-list/producto-list.component';
import { ProductoFormComponent } from './pages/productos/producto-form/producto-form.component';

// Categorías de Producto
import { CategoriaProductoListComponent } from './pages/productos/categoria-producto-list/categoria-producto-list.component';
import { CategoriaProductoFormComponent } from './pages/productos/categoria-producto-form/categoria-producto-form.component';

// Product Bundles
import { ProductBundleListComponent } from './pages/productos/product-bundle-list/product-bundle-list.component';
import { ProductBundleFormComponent } from './pages/productos/product-bundle-form/product-bundle-form.component';

// Tipos de Cambio (Inc 52 — submódulo Monedas)
import { ProductoCurrencyRatesComponent } from './pages/productos/producto-currency-rates/producto-currency-rates.component';
// Listas de Precios y Reglas de Descuento
import { PriceListListComponent } from './pages/productos/price-list-list/price-list-list.component';
import { PriceListFormComponent } from './pages/productos/price-list-form/price-list-form.component';
import { DiscountRuleListComponent } from './pages/productos/discount-rule-list/discount-rule-list.component';
import { DiscountRuleFormComponent } from './pages/productos/discount-rule-form/discount-rule-form.component';

// Quotes
import { QuotesListComponent } from './pages/quotes/quotes-list/quotes-list.component';
import { QuotesFormComponent } from './pages/quotes/quotes-form/quotes-form.component';
import { QuoteTemplateListComponent } from './pages/quotes/quote-template-list/quote-template-list.component';
import { QuoteTemplateFormComponent } from './pages/quotes/quote-template-form/quote-template-form.component';
import { QuoteContentTemplateListComponent } from './pages/quotes/quote-content-template-list/quote-content-template-list.component';
import { QuoteContentTemplateFormComponent } from './pages/quotes/quote-content-template-form/quote-content-template-form.component';
import { QuoteApproverListComponent } from './pages/quotes/quote-approvers/quote-approver-list/quote-approver-list.component';

// Business
import { BusinessListComponent } from './pages/businesses/business-list/business-list.component';
import { BusinessFormComponent } from './pages/businesses/business-form/business-form.component';

// Configuración Contactos — Estados
import { ContactStateListComponent } from './pages/contact-states/contact-state-list/contact-state-list.component';
import { ContactStateFormComponent } from './pages/contact-states/contact-state-form/contact-state-form.component';

// Configuración Contactos — Ciclos
import { ContactCycleListComponent } from './pages/contact-cycles/contact-cycle-list/contact-cycle-list.component';
import { ContactCycleFormComponent } from './pages/contact-cycles/contact-cycle-form/contact-cycle-form.component';

// Configuración Contactos — Atributos
import { ContactAttributeListComponent } from './pages/contact-attributes/contact-attribute-list/contact-attribute-list.component';
import { ContactAttributeFormComponent } from './pages/contact-attributes/contact-attribute-form/contact-attribute-form.component';

// Configuración Contactos — Definiciones de Atributo
import { ContactAttributeDefinitionListComponent } from './pages/contact-attribute-definitions/contact-attribute-definition-list/contact-attribute-definition-list.component';
import { ContactAttributeDefinitionFormComponent } from './pages/contact-attribute-definitions/contact-attribute-definition-form/contact-attribute-definition-form.component';

// Configuración Contactos — Reglas
import { ContactCycleRuleListComponent } from './pages/contact-cycle-rules/contact-cycle-rule-list/contact-cycle-rule-list.component';
import { ContactCycleRuleFormComponent } from './pages/contact-cycle-rules/contact-cycle-rule-form/contact-cycle-rule-form.component';

// Configuración Contactos — Orígenes
import { ContactOriginListComponent } from './pages/contact-origins/contact-origin-list/contact-origin-list.component';
import { ContactOriginFormComponent } from './pages/contact-origins/contact-origin-form/contact-origin-form.component';

// Leads
import { LeadListComponent } from './pages/leads/lead-list/lead-list.component';
import { LeadFormComponent } from './pages/leads/lead-form/lead-form.component';
import { LeadKanbanComponent } from './pages/leads/lead-kanban/lead-kanban.component';

// Configuración Leads — Estados
import { LeadStateListComponent } from './pages/lead-states/lead-state-list/lead-state-list.component';
import { LeadStateFormComponent } from './pages/lead-states/lead-state-form/lead-state-form.component';

// Configuración Leads — Ciclos
import { LeadCycleListComponent } from './pages/lead-cycles/lead-cycle-list/lead-cycle-list.component';
import { LeadCycleFormComponent } from './pages/lead-cycles/lead-cycle-form/lead-cycle-form.component';

// Configuración Leads — Razones de Descalificación
import { LeadDisqualificationReasonListComponent } from './pages/lead-disqualification-reasons/lead-disqualification-reason-list/lead-disqualification-reason-list.component';
import { LeadDisqualificationReasonFormComponent } from './pages/lead-disqualification-reasons/lead-disqualification-reason-form/lead-disqualification-reason-form.component';

// Configuración Leads — Atributos
import { LeadAttributeListComponent } from './pages/lead-attributes/lead-attribute-list/lead-attribute-list.component';
import { LeadAttributeFormComponent } from './pages/lead-attributes/lead-attribute-form/lead-attribute-form.component';

// Configuración Leads — Reglas de Ciclo
import { LeadCycleRuleListComponent } from './pages/lead-cycle-rules/lead-cycle-rule-list/lead-cycle-rule-list.component';
import { LeadCycleRuleFormComponent } from './pages/lead-cycle-rules/lead-cycle-rule-form/lead-cycle-rule-form.component';

// Configuración Empresas — Estados
import { CompanyStateLeadListComponent } from './pages/company-state-leads/company-state-lead-list/company-state-lead-list.component';
import { CompanyStateLeadFormComponent } from './pages/company-state-leads/company-state-lead-form/company-state-lead-form.component';

// Configuración Empresas — Ciclos
import { CompanyCycleListComponent } from './pages/company-cycles/company-cycle-list/company-cycle-list.component';
import { CompanyCycleFormComponent } from './pages/company-cycles/company-cycle-form/company-cycle-form.component';

// Configuración Empresas — Tipos de Relación
import { CompanyRelationshipTypeListComponent } from './pages/company-relationship-types/company-relationship-type-list/company-relationship-type-list.component';
import { CompanyRelationshipTypeFormComponent } from './pages/company-relationship-types/company-relationship-type-form/company-relationship-type-form.component';

// Configuración Empresas — Tamaños
import { CompanySizeListComponent } from './pages/company-sizes/company-size-list/company-size-list.component';
import { CompanySizeFormComponent } from './pages/company-sizes/company-size-form/company-size-form.component';

// Configuración Empresas — Sectores
import { CompanySectorListComponent } from './pages/company-sectors/company-sector-list/company-sector-list.component';
import { CompanySectorFormComponent } from './pages/company-sectors/company-sector-form/company-sector-form.component';

// Configuración Empresas — Tipos de Documento
import { CompanyTaxTypeListComponent } from './pages/company-tax-types/company-tax-type-list/company-tax-type-list.component';
import { CompanyTaxTypeFormComponent } from './pages/company-tax-types/company-tax-type-form/company-tax-type-form.component';

// Configuración Deals — Ciclos
import { DealCycleListComponent } from './pages/deal-cycles/deal-cycle-list/deal-cycle-list.component';
import { DealCycleFormComponent } from './pages/deal-cycles/deal-cycle-form/deal-cycle-form.component';

// Configuración Deals — Orígenes
import { DealOriginListComponent } from './pages/deal-origins/deal-origin-list/deal-origin-list.component';
import { DealOriginFormComponent } from './pages/deal-origins/deal-origin-form/deal-origin-form.component';

// Configuración Deals — Tipos de Negocio
import { DealBusinessTypeListComponent } from './pages/deal-business-types/deal-business-type-list/deal-business-type-list.component';
import { DealBusinessTypeFormComponent } from './pages/deal-business-types/deal-business-type-form/deal-business-type-form.component';

// Configuración Deals — Prioridades
import { DealPriorityListComponent } from './pages/deal-priorities/deal-priority-list/deal-priority-list.component';
import { DealPriorityFormComponent } from './pages/deal-priorities/deal-priority-form/deal-priority-form.component';

// Configuración Deals — Roles de Contacto
import { DealContactRoleListComponent } from './pages/deal-contact-roles/deal-contact-role-list/deal-contact-role-list.component';
import { DealContactRoleFormComponent } from './pages/deal-contact-roles/deal-contact-role-form/deal-contact-role-form.component';

// Configuración Deals — Campos Personalizados
import { DealAttributeDefinitionListComponent } from './pages/deal-attribute-definitions/deal-attribute-definition-list/deal-attribute-definition-list.component';
import { DealAttributeDefinitionFormComponent } from './pages/deal-attribute-definitions/deal-attribute-definition-form/deal-attribute-definition-form.component';

// Configuracion de meeting
import { MeetingListComponent } from './pages/meeting/meeting-list/meeting-list.component';
import { MeetingFormComponent } from './pages/meeting/meeting-form/meeting-form.component';
import { MeetingCalendarComponent } from './pages/meeting/meeting-calendar/meeting-calendar.component';
import { MeetingKanbanComponent } from './pages/meeting/meeting-kanban/meeting-kanban.component';
import { MeetingHorarioComponent } from './pages/meeting/meeting-horario/meeting-horario.component';
import { BookingLinkListComponent } from './pages/meeting/booking-link-list/booking-link-list.component';
import { BookingLinkFormComponent } from './pages/meeting/booking-link-form/booking-link-form.component';
import { PublicBookingComponent } from './pages/meeting/public-booking/public-booking.component';
import { PublicMeetingActionComponent } from './pages/meeting/public-meeting-action/public-meeting-action.component';
import { PublicMeetingRoomComponent } from './pages/meeting/public-meeting-room/public-meeting-room.component';
import { PublicQuoteComponent } from './pages/quotes/public-quote/public-quote.component';
import { CancellationReasonsListComponent } from './pages/meeting/config/cancellation-reasons/cancellation-reasons-list/cancellation-reasons-list.component';
import { HolidaysListComponent } from './pages/meeting/config/holidays/holidays-list/holidays-list.component';
import { EmailTemplatesListComponent } from './pages/meeting/config/email-templates/email-templates-list.component';
import { EmailTemplatesFormComponent } from './pages/meeting/config/email-templates/email-templates-form.component';
import { RoutingRulesListComponent } from './pages/meeting/config/routing-rules/routing-rules-list.component';
import { RoutingRulesFormComponent } from './pages/meeting/config/routing-rules/routing-rules-form.component';
import { MeetingTypesListComponent } from './pages/meeting/config/meeting-types/meeting-types-list/meeting-types-list.component';
import { MeetingStatusesListComponent } from './pages/meeting/config/meeting-statuses/meeting-statuses-list/meeting-statuses-list.component';
import { AvailabilityOverridesListComponent } from './pages/meeting/config/availability-overrides/availability-overrides-list/availability-overrides-list.component';

// users
// Users
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { UserFormComponent } from './pages/users/user-form/user-form.component';

// Roles
import { RoleListComponent } from './pages/roles/role-list/role-list.component';

// Invitations
import { InvitationListComponent } from './pages/invitations/invitation-list/invitation-list.component';
import { AccessRequestListComponent } from './pages/access-requests/access-request-list/access-request-list.component';

// Invitation Templates
import { InvitationTemplateListComponent } from './pages/invitation-templates/invitation-template-list/invitation-template-list.component';
import { InvitationTemplateFormComponent } from './pages/invitation-templates/invitation-template-form/invitation-template-form.component';

// Email Config
import { EmailConfigPageComponent } from './pages/email-config/email-config-page/email-config-page.component';
import { EmailChannelPolicyListComponent } from './pages/email-channel-policies/email-channel-policy-list/email-channel-policy-list.component';
import { BusinessEmailLimitsComponent } from './pages/business-email-limits/business-email-limits-list/business-email-limits.component';

// Correo — Bandeja de entrada (IMAP) + conexión SMTP/IMAP del usuario
import { InboxListComponent } from './pages/email-inbox/inbox-list/inbox-list.component';
import { SmtpConnectionFormComponent } from './pages/email-inbox/smtp-connection-form/smtp-connection-form.component';

// Correos enviados — historial de correos del usuario (GET /api/emails/mine)
import { CorreosListComponent } from './pages/correos/correos-list/correos-list.component';

// Canales de comunicación — hub de canales + matriz de notificaciones a contactos.
// Se cargan lazy (loadComponent) para no engordar el bundle inicial.

// Audit
import { AuditLogsComponent } from './pages/audit/audit-logs/audit-logs.component';
import { AuditAuthLogsComponent } from './pages/audit/audit-auth-logs/audit-auth-logs.component';
import { AuditSettingsComponent } from './pages/audit/audit-settings/audit-settings.component';

// Accept Invite
import { AcceptInviteComponent } from './pages/auth-pages/accept-invite/accept-invite.component';

// Reset / Forgot Password (público)
import { ResetPasswordComponent } from './pages/auth-pages/reset-password/reset-password.component';

// Prudctos vista grid view
import { ChatflowListComponent } from './pages/chatflows/chatflow-list/chatflow-list.component';
import { ChatflowTemplatesComponent } from './pages/chatflows/chatflow-templates/chatflow-templates.component';
import { ChatTeamsListComponent } from './pages/chatflows/chat-teams/chat-teams-list/chat-teams-list.component';
import { ChatTeamsDetailComponent } from './pages/chatflows/chat-teams/chat-teams-detail/chat-teams-detail.component';
import { ChatflowFormComponent } from './pages/chatflows/chatflow-form/chatflow-form.component';
import { KnowledgeMetricsComponent } from './pages/chatflows/knowledge-metrics/knowledge-metrics.component';


import { AgentConversationsLayoutComponent } from './pages/agent-conversations/agent-conversations-layout.component';
import { CallComponent } from './pages/call/call.component';
import { CallProviderConfigComponent } from './pages/call/call-provider-config/call-provider-config.component';
import { PhoneNumberListComponent } from './pages/call/phone-number-list/phone-number-list.component';
import { CallMetricsComponent } from './pages/call/call-metrics/call-metrics.component';

// WhatsApp
import { WhatsappSetupComponent } from './pages/whatsapp/whatsapp-setup/whatsapp-setup.component';
import { WhatsappInboxComponent } from './pages/whatsapp/whatsapp-inbox/whatsapp-inbox.component';
import { WhatsappTemplatesComponent } from './pages/whatsapp/whatsapp-templates/whatsapp-templates.component';
import { WhatsappContactCleanupComponent } from './pages/whatsapp/whatsapp-contact-cleanup/whatsapp-contact-cleanup.component';




// Plantillas de correo (Templates) — el form se carga lazy para mantener
// margen en el bundle inicial (template-form trae editor WYSIWYG).
import { TemplateListComponent } from './pages/templates/template-list/template-list.component';

// tareas
import { TareasListComponent } from './pages/tasks/task-list/tareas-list.component';
import { TareaKambanComponent } from './pages/tasks/task-kamban/tareas-kamban.component';
import { TaskCalendarComponent } from './pages/tasks/task-calendar/tareas-calendar.component';
import { TareasFormComponent } from './pages/tasks/task-from/tareas-form.component';

// Tickets
import { TicketsListComponent } from './pages/tickets/tickets-list/tickets-list.component';
import { TicketsFormComponent } from './pages/tickets/tickets-form/tickets-form.component';
import { TicketsKanbanComponent } from './pages/tickets/tickets-kanban/tickets-kanban.component';
import { TicketsDetailComponent } from './pages/tickets/tickets-detail/tickets-detail.component';
import { TicketsPrioritiesListComponent } from './pages/tickets/config/priorities/priorities-list/priorities-list.component';
import { TicketsCategoriesListComponent } from './pages/tickets/config/categories/categories-list/categories-list.component';
import { TicketsRootCausesListComponent } from './pages/tickets/config/root-causes/root-causes-list/root-causes-list.component';
import { TicketsCannedResponsesListComponent } from './pages/tickets/config/canned-responses/canned-responses-list/canned-responses-list.component';
import { TicketsSavedViewsListComponent } from './pages/tickets/config/saved-views/saved-views-list/saved-views-list.component';
import { TicketsPipelinesListComponent } from './pages/tickets/config/pipelines/pipelines-list/pipelines-list.component';
import { TicketsPipelinesDetailComponent } from './pages/tickets/config/pipelines/pipelines-detail/pipelines-detail.component';
import { TicketsTeamsListComponent } from './pages/tickets/config/teams/teams-list/teams-list.component';
import { TicketsTeamsDetailComponent } from './pages/tickets/config/teams/teams-detail/teams-detail.component';
import { TicketsSlaPoliciesListComponent } from './pages/tickets/config/sla-policies/sla-policies-list/sla-policies-list.component';
import { TicketsSlaPoliciesDetailComponent } from './pages/tickets/config/sla-policies/sla-policies-detail/sla-policies-detail.component';
import { TicketsAssignmentRulesListComponent } from './pages/tickets/config/assignment-rules/assignment-rules-list/assignment-rules-list.component';
import { TicketsEscalationRulesListComponent } from './pages/tickets/config/escalation-rules/escalation-rules-list/escalation-rules-list.component';

// Configuración Tareas
import { TaskTypesListComponent } from './pages/tasks/config/task-types/task-types-list/task-types-list.component';
import { TaskStatusesListComponent } from './pages/tasks/config/task-statuses/task-statuses-list/task-statuses-list.component';
import { TaskPrioritiesListComponent } from './pages/tasks/config/task-priorities/task-priorities-list/task-priorities-list.component';
import { TaskCategoriesListComponent } from './pages/tasks/config/task-categories/task-categories-list/task-categories-list.component';
import { TaskCancelReasonsListComponent } from './pages/tasks/config/task-cancel-reasons/task-cancel-reasons-list/task-cancel-reasons-list.component';

//Dashboard
import { DashboardPageComponent } from './pages/dashboard/dashboard-page/dashboard-page.component';

// Notificaciones in-app (centro de notificaciones / campana del header)
import { NotificationListComponent } from './pages/notifications/notification-list/notification-list.component';

// Automation — Workflows
import { WorkflowListComponent } from './pages/automation/workflows/workflow-list/workflow-list.component';
import { WorkflowFormComponent } from './pages/automation/workflows/workflow-form/workflow-form.component';
import { WorkflowFolderListComponent } from './pages/automation/workflows/workflow-folders/workflow-folder-list.component';
import { WorkflowBuilderComponent } from './pages/automation/workflows/workflow-builder/workflow-builder.component';
import { WorkflowEnrollmentsComponent } from './pages/automation/workflows/workflow-enrollments/workflow-enrollments.component';
import { WorkflowEventTesterComponent } from './pages/automation/workflows/workflow-event-tester/workflow-event-tester.component';
import { WorkflowEventQueueComponent } from './pages/automation/workflows/workflow-event-queue/workflow-event-queue.component';
import { WorkflowWaitQueueComponent } from './pages/automation/workflows/workflow-wait-queue/workflow-wait-queue.component';
import { WorkflowActionTesterComponent } from './pages/automation/workflows/workflow-action-tester/workflow-action-tester.component';
import { WorkflowCrmActionTesterComponent } from './pages/automation/workflows/workflow-crm-action-tester/workflow-crm-action-tester.component';
import { WorkflowActivityActionTesterComponent } from './pages/automation/workflows/workflow-activity-action-tester/workflow-activity-action-tester.component';
import { WorkflowPipelineActionTesterComponent } from './pages/automation/workflows/workflow-pipeline-action-tester/workflow-pipeline-action-tester.component';
import { WorkflowWebhookEndpointsComponent } from './pages/automation/workflows/workflow-webhook-endpoints/workflow-webhook-endpoints.component';
import { WorkflowWebhookActionTesterComponent } from './pages/automation/workflows/workflow-webhook-action-tester/workflow-webhook-action-tester.component';
import { WorkflowTestingComponent } from './pages/automation/workflows/workflow-testing/workflow-testing.component';
import { WorkflowMonitoringComponent } from './pages/automation/workflows/workflow-monitoring/workflow-monitoring.component';
import { WorkflowRecordHistoryComponent } from './pages/automation/workflows/workflow-record-history/workflow-record-history.component';

// Correo de Marketing (componentes pendientes de implementación)




// Public pages
//
// OJO: /privacy y /terms NO son rutas del SPA. Al usar hash routing
// (withHashLocation() en app.config.ts) una peticion a https://host/privacy
// llegaba sin hash y el router renderizaba la LANDING, con lo que la URL de la
// politica de privacidad mostraba la portada — rechazo seguro en la verificacion
// OAuth de Google. Ahora son HTML estatico: fe_crm/public/privacy.html y
// public/terms.html, servidos por las locations exactas de nginx.conf. Los enlaces
// del footer (href="/privacy") ya apuntaban ahi.
import { LandingComponent } from './pages/public/landing/landing.component';
import { TerminosYCondicionesComponent } from './pages/public/terminos-y-condiciones/terminos-y-condiciones.component';

/**
 * Redirige una ruta antigua de chatflow (`chatflows/:id/widget-config`, …) a su tab del
 * editor nuevo, conservando el :id.
 *
 * Se usa una función y no un string porque `redirectTo` en formato string no puede llevar
 * query params, y la tab activa viaja en `?tab=`.
 */
function editorTabRedirect(tab: string): RedirectFunction {
  return (route) => {
    const router = inject(Router);
    // Los query params de la URL original se conservan: la notificación de CSAT negativo
    // llega a `/chatflows/:id/csat?csatConversation=123` y ese id es justo lo que la
    // pestaña necesita para resaltar la valoración que disparó el aviso (INC_CRM_019 (8) inc60).
    return router.createUrlTree(['/chatflows', route.params['id'], 'editor'], {
      queryParams: { ...route.queryParams, tab }
    });
  };
}

export const routes: Routes = [
  // Landing — página inicial (redirige a /contactos si ya está autenticado)
  {
    path: '',
    component: LandingComponent,
    pathMatch: 'full',
    canActivate: [guestGuard],
    title: 'Partner CRM'
  },
  {
    path: 'home',
    component: LandingComponent,
    title: 'Partner CRM'
  },
  {
    path: 'terminos-y-condiciones',
    component: TerminosYCondicionesComponent,
    title: 'Términos y Condiciones | Partner CRM'
  },
  {
    path: 'f/:slug',
    component: PublicFormComponent,
    title: 'Formulario'
  },
  // Authenticated app shell — children are rendered inside AppLayoutComponent
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'contactos',
        pathMatch: 'full'
      },
      {
        path: 'agent/conversations',
        component: AgentConversationsLayoutComponent,
        title: 'Bandeja de Agente | CRM'
      },
      {
        path: 'contactos',
        component: ContactoKanbanComponent,
        title: 'Contactos | CRM'
      },
      {
        path: 'contactos/lista',
        component: ContactoListComponent,
        title: 'Lista de Contactos | CRM'
      },
      {
        path: 'contactos/kanban',
        component: ContactoKanbanComponent,
        title: 'Kanban de Contactos | CRM'
      },
      {
        path: 'contactos/crear',
        component: ContactoFormComponent,
        title: 'Nuevo Contacto | CRM'
      },
      {
        path: 'contactos/editar/:id',
        component: ContactoFormComponent,
        title: 'Editar Contacto | CRM'
      },
      // Empresas
      {
        path: 'empresas',
        component: EmpresaKanbanComponent,
        title: 'Empresas | CRM'
      },
      {
        path: 'empresas/lista',
        component: EmpresaListComponent,
        title: 'Lista de Empresas | CRM'
      },
      {
        path: 'empresas/kanban',
        component: EmpresaKanbanComponent,
        title: 'Kanban de Empresas | CRM'
      },
      {
        path: 'empresas/crear',
        component: EmpresaFormComponent,
        title: 'Nueva Empresa | CRM'
      },
      {
        path: 'empresas/editar/:id',
        component: EmpresaFormComponent,
        title: 'Editar Empresa | CRM'
      },
      // Negocios (Deals)
      {
        path: 'deals',
        component: DealKanbanComponent,
        title: 'Negocios | CRM'
      },
      {
        path: 'deals/lista',
        component: DealListComponent,
        title: 'Lista de Negocios | CRM'
      },
      {
        path: 'deals/kanban',
        component: DealKanbanComponent,
        title: 'Kanban de Negocios | CRM'
      },
      {
        path: 'deals/crear',
        component: DealFormComponent,
        title: 'Nuevo Negocio | CRM'
      },
      {
        path: 'deals/editar/:id',
        component: DealFormComponent,
        title: 'Editar Negocio | CRM'
      },
      // Productos
      {
        path: 'productos',
        component: ProductoListComponent,
        title: 'Productos | CRM'
      },
      {
        path: 'productos/crear',
        component: ProductoFormComponent,
        title: 'Nuevo Producto | CRM'
      },
      {
        path: 'productos/editar/:id',
        component: ProductoFormComponent,
        title: 'Editar Producto | CRM'
      },
      // Tipos de Cambio (Inc 52 — submódulo Monedas)
      {
        path: 'productos/tipos-cambio',
        component: ProductoCurrencyRatesComponent,
        title: 'Tipos de Cambio | CRM'
      },
      // Listas de Precios
      {
        path: 'productos/listas-precios',
        component: PriceListListComponent,
        title: 'Listas de Precios | CRM'
      },
      {
        path: 'productos/listas-precios/crear',
        component: PriceListFormComponent,
        title: 'Nueva Lista de Precios | CRM'
      },
      {
        path: 'productos/listas-precios/editar/:id',
        component: PriceListFormComponent,
        title: 'Editar Lista de Precios | CRM'
      },
      // Reglas de Descuento
      {
        path: 'productos/reglas-descuento',
        component: DiscountRuleListComponent,
        title: 'Reglas de Descuento | CRM'
      },
      {
        path: 'productos/reglas-descuento/crear',
        component: DiscountRuleFormComponent,
        title: 'Nueva Regla de Descuento | CRM'
      },
      {
        path: 'productos/reglas-descuento/editar/:id',
        component: DiscountRuleFormComponent,
        title: 'Editar Regla de Descuento | CRM'
      },
      // Categorías de Producto
      {
        path: 'categorias-producto',
        component: CategoriaProductoListComponent,
        title: 'Categorías de Producto | CRM'
      },
      {
        path: 'categorias-producto/crear',
        component: CategoriaProductoFormComponent,
        title: 'Nueva Categoría | CRM'
      },
      {
        path: 'categorias-producto/editar/:id',
        component: CategoriaProductoFormComponent,
        title: 'Editar Categoría | CRM'
      },
      // Product Bundles
      {
        path: 'bundles',
        component: ProductBundleListComponent,
        title: 'Bundles de Productos | CRM'
      },
      {
        path: 'bundles/crear',
        component: ProductBundleFormComponent,
        title: 'Nuevo Bundle | CRM'
      },
      {
        path: 'bundles/editar/:id',
        component: ProductBundleFormComponent,
        title: 'Editar Bundle | CRM'
      },
      //Meeting
      {
        path: 'meeting',
        component: MeetingListComponent,
        title: 'Reuniones | CRM'
      },
      {
        path: 'meeting/crear',
        component: MeetingFormComponent,
        title: 'Nueva Reunión | CRM'
      },
      {
        path: 'meeting/editar/:id',
        component: MeetingFormComponent,
        title: 'Editar Reunión | CRM'
      },
      {
        path: 'meeting/calendar',
        component: MeetingCalendarComponent,
        title: 'Calendario de Reuniones | CRM'
      },
      {
        path: 'meeting/kanban',
        component: MeetingKanbanComponent,
        title: 'Kanban | CRM'
      },
      {
        path: 'meeting/horario',
        component: MeetingHorarioComponent,
        title: 'Horario | CRM'
      },
      {
        path: 'meeting/booking-links',
        component: BookingLinkListComponent,
        title: 'Páginas de reserva | CRM'
      },
      {
        path: 'meeting/booking-links/crear',
        component: BookingLinkFormComponent,
        title: 'Nueva página de reserva | CRM'
      },
      {
        path: 'meeting/booking-links/editar/:id',
        component: BookingLinkFormComponent,
        title: 'Editar página de reserva | CRM'
      },
      // Meeting — Configuración
      {
        path: 'meeting/config/meeting-types',
        component: MeetingTypesListComponent,
        title: 'Tipos de reunión | CRM'
      },
      {
        path: 'meeting/config/meeting-statuses',
        component: MeetingStatusesListComponent,
        title: 'Estados de reunión | CRM'
      },
      {
        path: 'meeting/config/availability-overrides',
        component: AvailabilityOverridesListComponent,
        title: 'Excepciones de disponibilidad | CRM'
      },
      {
        path: 'meeting/config/cancellation-reasons',
        component: CancellationReasonsListComponent,
        title: 'Motivos de cancelación | CRM'
      },
      {
        path: 'meeting/config/holidays',
        component: HolidaysListComponent,
        title: 'Feriados | CRM'
      },
      {
        path: 'meeting/config/email-templates',
        component: EmailTemplatesListComponent,
        title: 'Plantillas de email | CRM'
      },
      {
        path: 'meeting/config/email-templates/crear',
        component: EmailTemplatesFormComponent,
        title: 'Nueva plantilla | CRM'
      },
      {
        path: 'meeting/config/email-templates/editar/:id',
        component: EmailTemplatesFormComponent,
        title: 'Editar plantilla | CRM'
      },
      {
        path: 'meeting/config/routing-rules',
        component: RoutingRulesListComponent,
        title: 'Reglas de routing | CRM'
      },
      {
        path: 'meeting/config/routing-rules/crear',
        component: RoutingRulesFormComponent,
        title: 'Nueva regla | CRM'
      },
      {
        path: 'meeting/config/routing-rules/editar/:id',
        component: RoutingRulesFormComponent,
        title: 'Editar regla | CRM'
      },
      // Quotes
      {
        path: 'cotizaciones',
        component: QuotesListComponent,
        title: 'Cotizaciones | CRM'
      },
      {
        path: 'cotizaciones/crear',
        component: QuotesFormComponent,
        title: 'Nueva Cotización | CRM'
      },
      {
        path: 'cotizaciones/editar/:id',
        component: QuotesFormComponent,
        title: 'Editar Cotización | CRM'
      },
      {
        path: 'cotizaciones/detalle/:id',
        loadComponent: () => import('./pages/quotes/quote-detail/quote-detail.component').then(m => m.QuoteDetailComponent),
        title: 'Detalle de Cotización | CRM'
      },
      // Quote Templates
      {
        path: 'cotizaciones/plantillas',
        component: QuoteTemplateListComponent,
        title: 'Plantillas de Cotización | CRM'
      },
      {
        path: 'cotizaciones/plantillas/crear',
        component: QuoteTemplateFormComponent,
        title: 'Nueva Plantilla | CRM'
      },
      {
        path: 'cotizaciones/plantillas/editar/:id',
        component: QuoteTemplateFormComponent,
        title: 'Editar Plantilla | CRM'
      },
      // Quote Content Templates (reusable products/services + terms)
      {
        path: 'cotizaciones/plantillas-contenido',
        component: QuoteContentTemplateListComponent,
        title: 'Plantillas de Contenido | CRM'
      },
      {
        path: 'cotizaciones/plantillas-contenido/crear',
        component: QuoteContentTemplateFormComponent,
        title: 'Nueva Plantilla de Contenido | CRM'
      },
      {
        path: 'cotizaciones/plantillas-contenido/editar/:id',
        component: QuoteContentTemplateFormComponent,
        title: 'Editar Plantilla de Contenido | CRM'
      },
      // Responsables de aprobación de cotizaciones (firma registrada)
      {
        path: 'cotizaciones/responsables',
        component: QuoteApproverListComponent,
        title: 'Responsables de aprobación | CRM'
      },
      // Configuración Contactos — Estados
      {
        path: 'config-contactos/estados',
        component: ContactStateListComponent,
        title: 'Estados de Contacto | CRM'
      },
      {
        path: 'config-contactos/estados/crear',
        component: ContactStateFormComponent,
        title: 'Nuevo Estado de Contacto | CRM'
      },
      {
        path: 'config-contactos/estados/editar/:id',
        component: ContactStateFormComponent,
        title: 'Editar Estado de Contacto | CRM'
      },
      // Configuración Contactos — Ciclos
      {
        path: 'config-contactos/ciclos',
        component: ContactCycleListComponent,
        title: 'Ciclos | CRM'
      },
      {
        path: 'config-contactos/ciclos/crear',
        component: ContactCycleFormComponent,
        title: 'Nuevo Ciclo | CRM'
      },
      {
        path: 'config-contactos/ciclos/editar/:id',
        component: ContactCycleFormComponent,
        title: 'Editar Ciclo | CRM'
      },
      // Configuración Contactos — Atributos
      {
        path: 'config-contactos/atributos',
        component: ContactAttributeListComponent,
        title: 'Atributos | CRM'
      },
      {
        path: 'config-contactos/atributos/crear',
        component: ContactAttributeFormComponent,
        title: 'Nuevo Atributo | CRM'
      },
      {
        path: 'config-contactos/atributos/editar/:id',
        component: ContactAttributeFormComponent,
        title: 'Editar Atributo | CRM'
      },
      // Configuración Contactos — Definiciones de Atributo
      {
        path: 'config-contactos/definiciones',
        component: ContactAttributeDefinitionListComponent,
        title: 'Definiciones de Atributo | CRM'
      },
      {
        path: 'config-contactos/definiciones/crear',
        component: ContactAttributeDefinitionFormComponent,
        title: 'Nueva Definición | CRM'
      },
      {
        path: 'config-contactos/definiciones/editar/:id',
        component: ContactAttributeDefinitionFormComponent,
        title: 'Editar Definición | CRM'
      },
      // Configuración Contactos — Reglas
      {
        path: 'config-contactos/reglas',
        component: ContactCycleRuleListComponent,
        title: 'Reglas de Ciclo | CRM'
      },
      {
        path: 'config-contactos/reglas/crear',
        component: ContactCycleRuleFormComponent,
        title: 'Nueva Regla | CRM'
      },
      {
        path: 'config-contactos/reglas/editar/:id',
        component: ContactCycleRuleFormComponent,
        title: 'Editar Regla | CRM'
      },
      // Configuración Contactos — Orígenes
      {
        path: 'config-contactos/origenes',
        component: ContactOriginListComponent,
        title: 'Orígenes de Contacto | CRM'
      },
      {
        path: 'config-contactos/origenes/crear',
        component: ContactOriginFormComponent,
        title: 'Nuevo Origen | CRM'
      },
      {
        path: 'config-contactos/origenes/editar/:id',
        component: ContactOriginFormComponent,
        title: 'Editar Origen | CRM'
      },

      //Segmentos y Listas (contactos)
      {
        path: 'segmentos',
        component: SegmentListComponent,
        title: 'Segmentos de Listas de Contactos | CRM'
      },
      {
        path: 'segmentos/crear',
        component: SegmentFormComponent,
        title: 'Nuevo Segmento | CRM'
      },
      {
        path: 'segmentos/:id/editar',
        component: SegmentFormComponent,
        title: 'Editar Segmento | CRM'
      },

      // tickets
      {
        path: 'tickets',
        component: TicketsListComponent,
        title: 'Tickets | CRM'
      },
      {
        path: 'tickets/crear',
        component: TicketsFormComponent,
        title: 'Nuevo Ticket | CRM'
      },
      {
        path: 'tickets/kanban',
        component: TicketsKanbanComponent,
        title: 'Kanban de Tickets | CRM'
      },
      {
        path: 'tickets/editar/:id',
        component: TicketsFormComponent,
        title: 'Editar Ticket | CRM'
      },
      {
        // Detalle a página completa. El detalle "por defecto" sigue siendo el
        // modal sobre la lista (/tickets?openTicket=<id>); esta ruta es la que
        // ya asumía TicketsDetailComponent para recargarse al saltar entre
        // tickets (p. ej. de un padre a su sub-ticket) sin cambiar de vista.
        path: 'tickets/detalle/:id',
        component: TicketsDetailComponent,
        title: 'Detalle de Ticket | CRM'
      },
      {
        path: 'tickets/config/priorities',
        component: TicketsPrioritiesListComponent,
        title: 'Prioridades de Tickets | CRM'
      },
      {
        path: 'tickets/config/categories',
        component: TicketsCategoriesListComponent,
        title: 'Categorías de Tickets | CRM'
      },
      {
        path: 'tickets/config/root-causes',
        component: TicketsRootCausesListComponent,
        title: 'Causas Raíz | CRM'
      },
      {
        path: 'tickets/config/canned-responses',
        component: TicketsCannedResponsesListComponent,
        title: 'Plantillas de respuesta | CRM'
      },
      {
        path: 'tickets/config/saved-views',
        component: TicketsSavedViewsListComponent,
        title: 'Vistas guardadas | CRM'
      },
      {
        path: 'tickets/config/pipelines',
        component: TicketsPipelinesListComponent,
        title: 'Pipelines | CRM'
      },
      {
        path: 'tickets/config/pipelines/:id',
        component: TicketsPipelinesDetailComponent,
        title: 'Etapas del pipeline | CRM'
      },
      {
        path: 'tickets/config/teams',
        component: TicketsTeamsListComponent,
        title: 'Equipos de soporte | CRM'
      },
      {
        path: 'tickets/config/teams/:id',
        component: TicketsTeamsDetailComponent,
        title: 'Miembros del equipo | CRM'
      },
      {
        path: 'tickets/config/sla-policies',
        component: TicketsSlaPoliciesListComponent,
        title: 'Políticas SLA | CRM'
      },
      {
        path: 'tickets/config/sla-policies/:id',
        component: TicketsSlaPoliciesDetailComponent,
        title: 'Objetivos SLA | CRM'
      },
      {
        path: 'tickets/config/assignment-rules',
        component: TicketsAssignmentRulesListComponent,
        title: 'Reglas de asignación | CRM'
      },
      {
        path: 'tickets/config/escalation-rules',
        component: TicketsEscalationRulesListComponent,
        title: 'Reglas de escalación | CRM'
      },
      // Leads
      {
        path: 'leads',
        component: LeadKanbanComponent,
        title: 'Leads | CRM'
      },
      {
        path: 'leads/lista',
        component: LeadListComponent,
        title: 'Lista de Leads | CRM'
      },
      {
        path: 'leads/kanban',
        component: LeadKanbanComponent,
        title: 'Kanban de Leads | CRM'
      },
      {
        path: 'leads/crear',
        component: LeadFormComponent,
        title: 'Nuevo Lead | CRM'
      },
      {
        path: 'leads/editar/:id',
        component: LeadFormComponent,
        title: 'Editar Lead | CRM'
      },
      // Configuración Leads — Tipos (entidad interna: lead_state)
      {
        path: 'config-leads/tipos',
        component: LeadStateListComponent,
        title: 'Tipos de Lead | CRM'
      },
      {
        path: 'config-leads/tipos/crear',
        component: LeadStateFormComponent,
        title: 'Nuevo Tipo de Lead | CRM'
      },
      {
        path: 'config-leads/tipos/editar/:id',
        component: LeadStateFormComponent,
        title: 'Editar Tipo de Lead | CRM'
      },
      // Rutas antiguas /config-leads/estados: se conservan como redirect para no romper
      // enlaces guardados. La entidad interna sigue siendo lead_state; solo cambió la URL.
      { path: 'config-leads/estados', redirectTo: 'config-leads/tipos', pathMatch: 'full' },
      { path: 'config-leads/estados/crear', redirectTo: 'config-leads/tipos/crear', pathMatch: 'full' },
      { path: 'config-leads/estados/editar/:id', redirectTo: 'config-leads/tipos/editar/:id', pathMatch: 'full' },
      // Configuración Leads — Ciclos
      {
        path: 'config-leads/ciclos',
        component: LeadCycleListComponent,
        title: 'Ciclos de Lead | CRM'
      },
      {
        path: 'config-leads/ciclos/crear',
        component: LeadCycleFormComponent,
        title: 'Nuevo Ciclo de Lead | CRM'
      },
      {
        path: 'config-leads/ciclos/editar/:id',
        component: LeadCycleFormComponent,
        title: 'Editar Ciclo de Lead | CRM'
      },
      // Configuración Leads — Razones de Descalificación
      {
        path: 'config-leads/razones-descalificacion',
        component: LeadDisqualificationReasonListComponent,
        title: 'Razones de Descalificación | CRM'
      },
      {
        path: 'config-leads/razones-descalificacion/crear',
        component: LeadDisqualificationReasonFormComponent,
        title: 'Nueva Razón de Descalificación | CRM'
      },
      {
        path: 'config-leads/razones-descalificacion/editar/:id',
        component: LeadDisqualificationReasonFormComponent,
        title: 'Editar Razón de Descalificación | CRM'
      },
      // Configuración Leads — Atributos
      {
        path: 'config-leads/atributos',
        component: LeadAttributeListComponent,
        title: 'Atributos de Lead | CRM'
      },
      {
        path: 'config-leads/atributos/crear',
        component: LeadAttributeFormComponent,
        title: 'Nuevo Atributo de Lead | CRM'
      },
      {
        path: 'config-leads/atributos/editar/:id',
        component: LeadAttributeFormComponent,
        title: 'Editar Atributo de Lead | CRM'
      },
      // Configuración Leads — Reglas de Ciclo
      {
        path: 'config-leads/reglas',
        component: LeadCycleRuleListComponent,
        title: 'Reglas de Ciclo de Lead | CRM'
      },
      {
        path: 'config-leads/reglas/crear',
        component: LeadCycleRuleFormComponent,
        title: 'Nueva Regla de Ciclo | CRM'
      },
      {
        path: 'config-leads/reglas/editar/:id',
        component: LeadCycleRuleFormComponent,
        title: 'Editar Regla de Ciclo | CRM'
      },
      // Configuración Empresas — Estados
      {
        path: 'config-empresas/estados',
        component: CompanyStateLeadListComponent,
        title: 'Estados de Empresa | CRM'
      },
      {
        path: 'config-empresas/estados/crear',
        component: CompanyStateLeadFormComponent,
        title: 'Nuevo Estado de Empresa | CRM'
      },
      {
        path: 'config-empresas/estados/editar/:id',
        component: CompanyStateLeadFormComponent,
        title: 'Editar Estado de Empresa | CRM'
      },
      // Configuración Empresas — Ciclos
      {
        path: 'config-empresas/ciclos',
        component: CompanyCycleListComponent,
        title: 'Ciclos de Empresa | CRM'
      },
      {
        path: 'config-empresas/ciclos/crear',
        component: CompanyCycleFormComponent,
        title: 'Nuevo Ciclo de Empresa | CRM'
      },
      {
        path: 'config-empresas/ciclos/editar/:id',
        component: CompanyCycleFormComponent,
        title: 'Editar Ciclo de Empresa | CRM'
      },
      // Configuración Empresas — Tipos de Relación
      {
        path: 'config-empresas/tipos-relacion',
        component: CompanyRelationshipTypeListComponent,
        title: 'Tipos de Relación de Empresa | CRM'
      },
      {
        path: 'config-empresas/tipos-relacion/crear',
        component: CompanyRelationshipTypeFormComponent,
        title: 'Nuevo Tipo de Relación | CRM'
      },
      {
        path: 'config-empresas/tipos-relacion/editar/:id',
        component: CompanyRelationshipTypeFormComponent,
        title: 'Editar Tipo de Relación | CRM'
      },
      // Configuración Empresas — Tamaños
      {
        path: 'config-empresas/tamanios',
        component: CompanySizeListComponent,
        title: 'Tamaños de Empresa | CRM'
      },
      {
        path: 'config-empresas/tamanios/crear',
        component: CompanySizeFormComponent,
        title: 'Nuevo Tamaño de Empresa | CRM'
      },
      {
        path: 'config-empresas/tamanios/editar/:id',
        component: CompanySizeFormComponent,
        title: 'Editar Tamaño de Empresa | CRM'
      },
      // Configuración Empresas — Sectores
      {
        path: 'config-empresas/sectores',
        component: CompanySectorListComponent,
        title: 'Sectores de Empresa | CRM'
      },
      {
        path: 'config-empresas/sectores/crear',
        component: CompanySectorFormComponent,
        title: 'Nuevo Sector de Empresa | CRM'
      },
      {
        path: 'config-empresas/sectores/editar/:id',
        component: CompanySectorFormComponent,
        title: 'Editar Sector de Empresa | CRM'
      },

      {
        path: 'config-empresas/tipos-documento',
        component: CompanyTaxTypeListComponent,
        title: 'Tipos de Documento | CRM'
      },
      {
        path: 'config-empresas/tipos-documento/crear',
        component: CompanyTaxTypeFormComponent,
        title: 'Nuevo Tipo de Documento | CRM'
      },
      {
        path: 'config-empresas/tipos-documento/editar/:id',
        component: CompanyTaxTypeFormComponent,
        title: 'Editar Tipo de Documento | CRM'
      },
      // Configuración Deals — Ciclos
      { path: 'config-deals/ciclos', component: DealCycleListComponent, title: 'Etapas del Pipeline | CRM' },
      { path: 'config-deals/ciclos/crear', component: DealCycleFormComponent, title: 'Nueva Etapa | CRM' },
      { path: 'config-deals/ciclos/editar/:id', component: DealCycleFormComponent, title: 'Editar Etapa | CRM' },
      // Configuración Deals — Orígenes
      { path: 'config-deals/origenes', component: DealOriginListComponent, title: 'Orígenes de Negocio | CRM' },
      { path: 'config-deals/origenes/crear', component: DealOriginFormComponent, title: 'Nuevo Origen de Negocio | CRM' },
      { path: 'config-deals/origenes/editar/:id', component: DealOriginFormComponent, title: 'Editar Origen de Negocio | CRM' },
      // Configuración Deals — Tipos de Negocio
      { path: 'config-deals/tipos-negocio', component: DealBusinessTypeListComponent, title: 'Tipos de Negocio | CRM' },
      { path: 'config-deals/tipos-negocio/crear', component: DealBusinessTypeFormComponent, title: 'Nuevo Tipo de Negocio | CRM' },
      { path: 'config-deals/tipos-negocio/editar/:id', component: DealBusinessTypeFormComponent, title: 'Editar Tipo de Negocio | CRM' },
      // Configuración Deals — Prioridades
      { path: 'config-deals/prioridades', component: DealPriorityListComponent, title: 'Prioridades | CRM' },
      { path: 'config-deals/prioridades/crear', component: DealPriorityFormComponent, title: 'Nueva Prioridad | CRM' },
      { path: 'config-deals/prioridades/editar/:id', component: DealPriorityFormComponent, title: 'Editar Prioridad | CRM' },
      // Configuración Deals — Roles de Contacto
      { path: 'config-deals/roles-contacto', component: DealContactRoleListComponent, title: 'Roles de Contacto | CRM' },
      { path: 'config-deals/roles-contacto/crear', component: DealContactRoleFormComponent, title: 'Nuevo Rol de Contacto | CRM' },
      { path: 'config-deals/roles-contacto/editar/:id', component: DealContactRoleFormComponent, title: 'Editar Rol de Contacto | CRM' },
      // Configuración Deals — Campos Personalizados
      { path: 'config-deals/definiciones', component: DealAttributeDefinitionListComponent, title: 'Campos Personalizados Negocio | CRM' },
      { path: 'config-deals/definiciones/crear', component: DealAttributeDefinitionFormComponent, title: 'Nuevo Campo | CRM' },
      { path: 'config-deals/definiciones/editar/:id', component: DealAttributeDefinitionFormComponent, title: 'Editar Campo | CRM' },
      // Profile — INC_CRM_013 inc5: "Editar perfil" y "Configuración de cuenta"
      // son vistas distintas; /profile se conserva para no romper enlaces previos.
      {
        path: 'profile',
        component: ProfileComponent,
        title: 'Editar perfil | CRM'
      },
      {
        path: 'account-settings',
        component: AccountSettingsComponent,
        title: 'Configuración de cuenta | CRM'
      },
      // Currency
      {
        path: 'currency',
        component: CurrencyComponent,
        title: 'Monedas | CRM'
      },
      {
        path: 'currency-job-configs',
        component: CurrencyJobConfigsComponent,
        title: 'Programación de Monedas | CRM'
      },
      {
        path: 'currency-job-executions',
        component: CurrencyJobExecutionsComponent,
        title: 'Historial de Ejecuciones | CRM'
      },
      //Business
      {
        path: 'businesses',
        component: BusinessListComponent,
        canActivate: [superAdminGuard],
        title: 'Businesses | CRM'
      },
      {
        path: 'businesses/crear',
        component: BusinessFormComponent,
        canActivate: [superAdminGuard],
        title: 'Nuevo Business | CRM'
      },
      {
        path: 'businesses/editar/:id',
        component: BusinessFormComponent,
        canActivate: [superAdminGuard],
        title: 'Editar Business | CRM'
      },
      // Users
      {
        path: 'users',
        component: UserListComponent,
        title: 'Usuarios | CRM'
      },
      {
        path: 'users/crear',
        component: UserFormComponent,
        title: 'Nuevo Usuario | CRM'
      },
      {
        path: 'users/editar/:id',
        component: UserFormComponent,
        title: 'Editar Usuario | CRM'
      },
      // Roles y permisos
      {
        path: 'roles',
        component: RoleListComponent,
        title: 'Roles y permisos | CRM'
      },
      // Invitations
      {
        path: 'invitations',
        component: InvitationListComponent,
        title: 'Invitaciones | CRM'
      },
      // Solicitudes de acceso (bandeja de la pantalla publica /signup). Tabla
      // global sin businessId: solo Super Admin, igual que el backend.
      {
        path: 'access-requests',
        component: AccessRequestListComponent,
        canActivate: [superAdminGuard],
        title: 'Solicitudes de acceso | CRM'
      },
      // Invitation Templates
      {
        path: 'invitation-templates',
        component: InvitationTemplateListComponent,
        title: 'Plantillas de Invitación | CRM'
      },
      {
        path: 'invitation-templates/crear',
        component: InvitationTemplateFormComponent,
        title: 'Nueva Plantilla | CRM'
      },
      {
        path: 'invitation-templates/editar/:id',
        component: InvitationTemplateFormComponent,
        title: 'Editar Plantilla | CRM'
      },
      // Correo de Marketing
      {
        path: 'marketing-email',
        redirectTo: 'marketing-email/estado',
        pathMatch: 'full'
      },
      {
        path: 'marketing-email/estado',
        component: CampaignListComponent,
        title: 'Correo de Marketing | CRM'
      },
      // OJO con el orden: marketing-email/crear y /editar/:id deben ir
      // ANTES de marketing-email/:id (deep-link del detalle) — el wildcard `:id`
      // matchearía "crear" como id y abriría el modal de detalle con NaN.
      // El editor de contenido también debe ir antes de /editar/:id, sino
      // /editar/123/contenido matchea con /editar/:id si Angular lo intenta
      // en orden (igualmente Angular prefiere paths más específicos primero).
      {
        path: 'marketing-email/editar/:id/contenido',
        loadComponent: () =>
          import('./pages/marketing-email/campaign-content-editor/campaign-content-editor.component')
            .then(m => m.CampaignContentEditorComponent),
        title: 'Editar contenido | CRM'
      },
      {
        path: 'marketing-email/crear',
        component: CampaignFormComponent,
        title: 'Nuevo correo | CRM'
      },
      {
        path: 'marketing-email/editar/:id',
        component: CampaignFormComponent,
        title: 'Editar correo | CRM'
      },
      // Inc 29: el detalle de un correo es un MODAL sobre la lista (estándar del
      // CRM). La ruta se conserva como deep-link: renderiza la lista y
      // CampaignListComponent abre el modal con el `:id` recibido.
      {
        path: 'marketing-email/:id',
        component: CampaignListComponent,
        title: 'Correo | CRM'
      },
      // Formularios de Marketing
      {
        path: 'marketing-forms',
        component: FormsListComponent,
        title: 'Formularios de Marketing | CRM'
      },
      {
        path: 'marketing-forms/plantillas',
        component: TemplatesListComponent,
        title: 'Plantillas de Formularios | CRM'
      },
      {
        path: 'marketing-forms/:id/editor',
        component: FormEditorComponent,
        canDeactivate: [FormEditorGuard],
        title: 'Editor de Formulario | CRM'
      },
      {
        path: 'marketing-forms/:id/submissions',
        component: SubmissionsListComponent,
        title: 'Envíos del Formulario | CRM'
      },

      // Email Config
      {
        path: 'email-config',
        component: EmailConfigPageComponent,
        title: 'Configuración de Correo | CRM'
      },
      // Administración: políticas de rate-limit por canal de email (solo Super Admin)
      {
        path: 'admin/email-policies',
        component: EmailChannelPolicyListComponent,
        canActivate: [superAdminGuard],
        title: 'Políticas de canal de email | CRM'
      },
      // Configuración: límites de envío de email de la empresa (Admin o superior)
      {
        path: 'config/email-limits',
        component: BusinessEmailLimitsComponent,
        canActivate: [adminGuard],
        title: 'Límites de envío | CRM'
      },
      // Correo — Bandeja de entrada (IMAP) + conexión SMTP/IMAP del usuario
      {
        path: 'correo',
        component: InboxListComponent,
        title: 'Bandeja de entrada | CRM'
      },
      {
        path: 'correo/configuracion',
        component: SmtpConnectionFormComponent,
        title: 'Conexión de correo | CRM'
      },
      // Correos enviados — historial del usuario (GET /api/emails/mine)
      {
        path: 'correo/enviados',
        component: CorreosListComponent,
        title: 'Correos enviados | CRM'
      },
      // Canales de comunicación + notificaciones a contactos
      {
        path: 'correo/canales',
        loadComponent: () => import('./pages/communication-channels/channels-hub/channels-hub.component').then(m => m.ChannelsHubComponent),
        title: 'Canales de comunicación | CRM'
      },
      {
        path: 'correo/notificaciones',
        loadComponent: () => import('./pages/communication-channels/contact-notifications/contact-notifications.component').then(m => m.ContactNotificationsComponent),
        title: 'Notificaciones a contactos | CRM'
      },
      // Chatflows
      {
        path: 'chatflows',
        component: ChatflowListComponent,
        title: 'Chatflows | CRM'
      },
      {
        path: 'chatflows/plantillas',
        component: ChatflowTemplatesComponent,
        title: 'Plantillas de Chatflow | CRM'
      },
      {
        path: 'chatflows/equipos',
        component: ChatTeamsListComponent,
        title: 'Equipos de chat | CRM'
      },
      {
        path: 'chatflows/equipos/:id',
        component: ChatTeamsDetailComponent,
        title: 'Miembros del equipo | CRM'
      },
      {
        path: 'chatflows/crear',
        component: ChatflowFormComponent,
        title: 'Nuevo Chatflow | CRM'
      },
      // La edición de un chatflow existente vive ahora en la pestaña "Datos generales" del
      // editor, para que la lista tenga una sola acción "Editar" (INC_CRM_019 (3) inc19).
      // La ruta se conserva redirigiendo, para no romper enlaces guardados.
      { path: 'chatflows/editar/:id', redirectTo: editorTabRedirect('general') },
            {
        // Editor nuevo: shell con tabs (Flujo, Widget, Segmentación, Disponibilidad,
        // Reglas, Opciones, Analítica). Lazy: no entra en el bundle inicial.
        path: 'chatflows/:id/editor',
        loadComponent: () =>
          import('./pages/chatflows/chatflow-editor-shell/chatflow-editor-shell.component').then(
            (m) => m.ChatflowEditorShellComponent
          ),
        title: 'Editor de chatflow | CRM'
      },
      // Rutas antiguas: cada una redirige a su tab del editor para no romper los enlaces
      // que los usuarios ya tengan guardados.
      { path: 'chatflows/:id/builder', redirectTo: editorTabRedirect('flujo') },
      { path: 'chatflows/:id/display-rules', redirectTo: editorTabRedirect('segmentacion') },
      { path: 'chatflows/:id/widget-config', redirectTo: editorTabRedirect('widget') },
      { path: 'chatflows/:id/availability', redirectTo: editorTabRedirect('disponibilidad') },
      { path: 'chatflows/:id/routing-rules', redirectTo: editorTabRedirect('reglas') },
      { path: 'chatflows/:id/localization', redirectTo: editorTabRedirect('reglas') },
      { path: 'chatflows/:id/ticket-automation', redirectTo: editorTabRedirect('reglas') },
      { path: 'chatflows/:id/csat', redirectTo: editorTabRedirect('opciones') },
      { path: 'chatflows/:id/privacy', redirectTo: editorTabRedirect('opciones') },
      { path: 'chatflows/:id/analytics', redirectTo: editorTabRedirect('analitica') },
      // RF-08: Knowledge Metrics
      {
        path: 'chatflows/knowledge-metrics',
        component: KnowledgeMetricsComponent,
        title: 'Métricas Knowledge Base | CRM'
      },
      // Plantillas de correo
      {
        path: 'templates',
        component: TemplateListComponent,
        title: 'Plantillas de correo | CRM'
      },
      {
        path: 'templates/crear',
        loadComponent: () =>
          import('./pages/templates/template-form/template-form.component')
            .then(m => m.TemplateFormComponent),
        title: 'Nueva plantilla | CRM'
      },
      {
        path: 'templates/editar/:id',
        loadComponent: () =>
          import('./pages/templates/template-form/template-form.component')
            .then(m => m.TemplateFormComponent),
        title: 'Editar plantilla | CRM'
      },
      // Automation — Workflows
      {
        path: 'automation/workflows',
        component: WorkflowListComponent,
        title: 'Workflows | CRM'
      },
      {
        path: 'automation/workflows/crear',
        component: WorkflowFormComponent,
        title: 'Nuevo Workflow | CRM'
      },
      {
        path: 'automation/workflows/:id/editar',
        component: WorkflowFormComponent,
        title: 'Editar Workflow | CRM'
      },
      {
        path: 'automation/workflows/:id/builder',
        component: WorkflowBuilderComponent,
        title: 'Constructor Workflow | CRM'
      },
      {
        path: 'automation/workflow-folders',
        component: WorkflowFolderListComponent,
        title: 'Carpetas de Workflows | CRM'
      },
      {
        path: 'automation/workflows/:id/enrollments',
        component: WorkflowEnrollmentsComponent,
        title: 'Inscripciones Workflow | CRM'
      },
      {
        path: 'automation/workflows/:id/testing',
        component: WorkflowTestingComponent,
        title: 'Pruebas y Activación | CRM'
      },
      {
        path: 'automation/workflows/:id/monitoring',
        component: WorkflowMonitoringComponent,
        title: 'Monitoreo Workflow | CRM'
      },
      {
        path: 'automation/workflows/:id/event-tester',
        component: WorkflowEventTesterComponent,
        title: 'Probar Disparadores | CRM'
      },
      {
        path: 'automation/workflow-events/queue',
        component: WorkflowEventQueueComponent,
        title: 'Cola de Eventos Workflow | CRM'
      },
      {
        path: 'automation/workflow-waits/queue',
        component: WorkflowWaitQueueComponent,
        title: 'Cola de Esperas Workflow | CRM'
      },
      {
        path: 'automation/workflow-actions/test',
        component: WorkflowActionTesterComponent,
        title: 'Probar Acciones Workflow | CRM'
      },
      {
        path: 'automation/workflow-actions/crm-test',
        component: WorkflowCrmActionTesterComponent,
        title: 'Probar Acciones CRM | CRM'
      },
      {
        path: 'automation/workflow-actions/activity-test',
        component: WorkflowActivityActionTesterComponent,
        title: 'Probar Acciones de Actividad | CRM'
      },
      {
        path: 'automation/workflow-actions/pipeline-test',
        component: WorkflowPipelineActionTesterComponent,
        title: 'Probar Acciones de Pipeline | CRM'
      },
      {
        path: 'automation/workflow-webhooks/endpoints',
        component: WorkflowWebhookEndpointsComponent,
        title: 'Endpoints Webhook | CRM'
      },
      {
        path: 'automation/workflow-actions/webhook-test',
        component: WorkflowWebhookActionTesterComponent,
        title: 'Probar Webhooks | CRM'
      },
      // Audit
      {
        path: 'audit/logs',
        component: AuditLogsComponent,
        title: 'Auditoría de Operaciones | CRM'
      },
      {
        path: 'audit/auth-logs',
        component: AuditAuthLogsComponent,
        title: 'Auditoría de Autenticación | CRM'
      },
      {
        path: 'audit/settings',
        component: AuditSettingsComponent,
        title: 'Configuración de Auditoría | CRM'
      },

      //Llamadas
      {
        path: 'call',
        component: CallComponent,
        title: 'Llamadas | CRM'
      },
      {
        path: 'call/config',
        component: CallProviderConfigComponent,
        title: 'Configuración Twilio | CRM'
      },
      {
        path: 'call/phone-numbers',
        component: PhoneNumberListComponent,
        title: 'Números telefónicos | CRM'
      },
      {
        path: 'call/metrics',
        component: CallMetricsComponent,
        title: 'Métricas de llamadas | CRM'
      },
      // WhatsApp
      {
        path: 'whatsapp/chat',
        component: WhatsappInboxComponent,
        title: 'WhatsApp | CRM'
      },
      {
        path: 'whatsapp/setup',
        component: WhatsappSetupComponent,
        title: 'Configuración WhatsApp | CRM'
      },
      {
        path: 'whatsapp/plantillas',
        component: WhatsappTemplatesComponent,
        title: 'Plantillas de WhatsApp | CRM'
      },
      {
        // Herramienta destructiva: los dos endpoints exigen rol Admin/Super Admin, así que
        // la ruta lleva `adminGuard` y el ítem del menú se oculta con la misma regla —
        // dejar entrar a los demás sólo les daría un 403 en la cara.
        path: 'whatsapp/limpieza-contactos',
        component: WhatsappContactCleanupComponent,
        canActivate: [adminGuard],
        title: 'Limpieza de contactos de WhatsApp | CRM'
      },
      {
        path: 'tareas',
        component: TareasListComponent,
        title: 'Tareas | CRM'
      },
      {
        path: 'tareas/kamban',
        component: TareaKambanComponent,
        title: 'Kamban | CRM'
      },
      {
        path: 'tareas/calendario',
        component: TaskCalendarComponent,
        title: 'Calendario | CRM'
      },
      {
        path: 'tareas/crear',
        component: TareasFormComponent,
        title: 'Nueva Tarea | CRM'
      },
      {
        path: 'tareas/editar/:id',
        component: TareasFormComponent,
        title: 'Editar Tarea | CRM'
      },
      {
        path: 'tareas/form',
        component: TareasFormComponent,
        title: 'Formulario | CRM'
      },

      // ===== Configuración de tareas =====
      {
        path: 'tareas/config/tipos',
        component: TaskTypesListComponent,
        title: 'Tipos de Tarea | CRM'
      },
      {
        path: 'tareas/config/estados',
        component: TaskStatusesListComponent,
        title: 'Estados de Tarea | CRM'
      },
      {
        path: 'tareas/config/prioridades',
        component: TaskPrioritiesListComponent,
        title: 'Prioridades de Tarea | CRM'
      },
      {
        path: 'tareas/config/categorias',
        component: TaskCategoriesListComponent,
        title: 'Categorías de Tarea | CRM'
      },
      {
        path: 'tareas/config/motivos-cancelacion',
        component: TaskCancelReasonsListComponent,
        title: 'Motivos de Cancelación | CRM'
      },
      {
        path: 'dashboard',
        component: DashboardPageComponent,
        title: 'Dashboard | CRM'
      },
      // Notificaciones in-app — página "Ver todas"
      {
        path: 'notificaciones',
        component: NotificationListComponent,
        title: 'Notificaciones | CRM'
      }


    ]
  },
  // auth pages
  {
    path: 'signin',
    component: SignInComponent,
    title: 'Sign In | CRM'
  },
  {
    // No es un alta de auto-servicio: Partner CRM se vende de forma asistida.
    // La pantalla ofrece canjear una invitación o solicitar acceso/demo.
    path: 'signup',
    component: SignUpComponent,
    title: 'Solicitar acceso | Partner CRM'
  },
  // OAuth callback
  {
    path: 'oauth/callback',
    component: SignInComponent,
    title: 'OAuth Callback | CRM'
  },
  // Invitation acceptance
  {
    path: 'invite/:token',
    component: AcceptInviteComponent,
    title: 'Aceptar Invitación | CRM'
  },
  // Recuperar / restablecer contraseña (dual: sin token = solicitar, con ?token= = restablecer)
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    title: 'Restablecer contraseña | CRM'
  },
  // Public quote view (shared via public token, no login)
  {
    path: 'cotizacion/:token',
    component: PublicQuoteComponent,
    title: 'Cotización'
  },
  // Public internal-approval decision page (tokenized link from the approver email, no login)
  {
    path: 'aprobacion/:token',
    loadComponent: () => import('./pages/quotes/public-quote-approval/public-quote-approval.component').then(m => m.PublicQuoteApprovalComponent),
    title: 'Aprobación de Cotización'
  },
  // Public booking page
  {
    path: 'book/:slug',
    component: PublicBookingComponent,
    title: 'Agendar reunión'
  },
  // Public meeting action (cancel/reschedule via token)
  {
    path: 'meeting-action/:token',
    component: PublicMeetingActionComponent,
    title: 'Acción sobre reunión'
  },
  {
    path: 'meeting-action',
    component: PublicMeetingActionComponent,
    title: 'Acción sobre reunión'
  },
  // Public meeting room (videollamada Jitsi via token, no login)
  {
    path: 'meeting-room/:token',
    component: PublicMeetingRoomComponent,
    title: 'Sala de reunión'
  },
  // Public ticket CSAT survey (tokenized link from the email, no login)
  {
    path: 'ticket-csat/:token',
    loadComponent: () =>
      import('./pages/tickets/public-ticket-csat/public-ticket-csat.component').then(
        m => m.PublicTicketCsatComponent
      ),
    title: 'Encuesta de satisfacción'
  },
  // Encuesta CSAT de chatflow desde el enlace del correo (token de un solo uso, sin login)
  {
    path: 'chat-csat/:token',
    loadComponent: () =>
      import('./pages/chatflows/chatflow-public-csat/chatflow-public-csat.component').then(
        m => m.ChatflowPublicCsatComponent
      ),
    title: 'Encuesta de satisfacción'
  },
  // Widget de chatflow embebible (se carga DENTRO del iframe que inyecta widget.js
  // en el sitio del cliente). Ruta pública: visitante anónimo, sin layout ni authGuard.
  {
    path: 'chat-widget/:businessId/:identifier',
    loadComponent: () =>
      import('./pages/chatflows/chatflow-widget-embed/chatflow-widget-embed.component').then(
        m => m.ChatflowWidgetEmbedComponent
      ),
    title: 'Chat'
  },
  // error pages
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Not Found | CRM'
  },
];
